<template>
  <div
    class="message_history"
    layout="column"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-custom-class="csv-loading"
  >
    <div class="mb-x2" layout="layout" layout-align="space-between-center">
      <div layout="layout" layout-align="start-end">
        <div class="mr-x1">
          <el-button
            class="el-button-mt"
            type="default"
            @click="$router.push('/twitter_instantwins/' + $route.params.campaignId)"
            ><i class="mdi mdi-arrow-left"></i>戻る</el-button
          >
        </div>
        <message-history-filter></message-history-filter>
      </div>
      <div v-if="campaign.id">
        <div class="mb-x1" layout layout-align="end-center">
          <span class="mr-x3">応募者数: {{ formatNumber(campaign.applicantsCount) }}</span
          ><span>応募総数: {{ formatNumber(campaign.entryCount) }}</span>
        </div>
        <div layout layout-align="end-center">
          <span class="mr-x3"
            >当選総数: {{ formatNumber(campaign.maxWinnerCount) }}(残り{{
              formatNumber(campaign.maxWinnerCount - campaign.winnerCount)
            }})</span
          ><span>回答者数: {{ formatNumber(campaign.responderCount) }}</span>
        </div>
      </div>
    </div>
    <el-card>
      <div class="mb-x2" layout layout-align="space-between-center">
        <div layout>
          <el-dropdown class="ml-x1" trigger="click" @command="openDialog">
            <el-button class="dropdown-button" type="default" :disabled="isDisabled"
              ><i class="mdi mdi-playlist-play mr-x1"></i>一括操作<i
                class="mdi mdi-chevron-down dropdown-arrow ml-x3"
              ></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in actionDialogs" :key="item.value" :command="item.value">{{
                item.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button class="ml-x1" type="default" @click="$refs.loseReasonDialog.open(campaign.id)"
            ><i class="mdi mdi-format-list-numbered"></i>落選理由ごとの件数</el-button
          >
        </div>
        <csv-download v-show="histories.length" :download="downloadCsv" />
      </div>
      <message-history-table
        v-if="histories.length"
        :data="histories"
        :options="params"
        :paginations="paginations"
        :onChangeSortBy="onChangeSortBy"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
        @change_flag="changeFlag"
        @open_message_history="openMessageHistory"
      ></message-history-table>
      <div class="message message-info" v-if="histories.length === 0 && loaded && !error">
        条件に該当するデータがありません。
      </div>
      <div v-if="error">
        <div class="message message-error">
          データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
        </div>
      </div>
    </el-card>
    <applicant-reset-dialog ref="applicantResetDialog"></applicant-reset-dialog>
    <applicant-import-dialog ref="applicantImportDialog"></applicant-import-dialog>
    <direct-message-history-dialog ref="directMessageHistoryDialog"></direct-message-history-dialog>
    <lose-reason-dialog ref="loseReasonDialog"></lose-reason-dialog>
  </div>
</template>

<style lang="scss">
.message_history {
  .csv-loading {
    .el-loading-spinner {
      top: 40vh;

      .el-loading-text {
        white-space: pre-line;
      }
    }
  }
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import CsvDownload from '@/client/components/_atoms/csv_download'
import api from '@/client/core/api'
import util from '@/client/core/util'
import ApplicantImportDialog from '@/client/features/twitter_instantwin_message_history/applicant_import_dialog'
import ApplicantResetDialog from '@/client/features/twitter_instantwin_message_history/applicant_reset_dialog'
import DirectMessageHistoryDialog from '@/client/features/twitter_instantwin_message_history/direct_message_history_dialog'
import LoseReasonDialog from '@/client/features/twitter_instantwin_message_history/lose_reason_dialog'
import MessageHistoryFilter from '@/client/features/twitter_instantwin_message_history/message_history_filter'
import MessageHistoryTable from '@/client/features/twitter_instantwin_message_history/message_history_table'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterInstantwinMessageHistoryStore } from '@/client/store/useTwitterInstantwinMessageHistoryStore'

export default defineComponent({
  components: {
    MessageHistoryFilter,
    MessageHistoryTable,
    ApplicantImportDialog,
    ApplicantResetDialog,
    DirectMessageHistoryDialog,
    LoseReasonDialog,
    CsvDownload
  },
  props: {
    campaign: Object
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      actionDialogs: [
        {
          label: '回答者インポート',
          value: 'import_responder'
        },
        {
          label: '回答者解除',
          value: 'reset_responder'
        }
      ]
    }
  },
  async created() {
    const params = {
      campaignId: this.$route.params.campaignId
    }
    this.setHistoryParams(params)
  },
  computed: {
    ...mapState(useSystemStore, {
      contractStatus: state => state.currentGroup.contractStatus
    }),
    ...mapState(useTwitterInstantwinMessageHistoryStore, {
      histories: state => state.histories,
      params: state => state.params,
      loaded: state => state.loaded,
      error: state => state.error,
      paginations: state => {
        return {
          pagingNo: state.params.pagingNo,
          limitCount: state.params.limitCount,
          total: state.total
        }
      }
    }),

    isDisabled() {
      if (!this.campaign || !this.campaign.account || !this.campaign.account.id) {
        return true
      }

      return this.contractStatus === 3
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useTwitterInstantwinMessageHistoryStore, ['fetchHistoryList', 'setHistoryParams', 'updateResponder']),

    /**
     * Open dialog
     * @param {string} value
     */
    openDialog(value: string) {
      if (value.indexOf('reset') !== -1) {
        TrackingService.sendEvent('click:IWメッセージ一覧(X)|一括操作|回答者解除')

        const type = value.replace('reset_', '')
        this.$refs.applicantResetDialog.open(type)
      } else {
        TrackingService.sendEvent('click:IWメッセージ一覧(X)|一括操作|回答者インポート')

        const type = value.replace('import_', '')
        this.$refs.applicantImportDialog.open(type)
      }
    },

    /**
     * ページを変更イベント
     * @param {number} pagingNo ページング
     */
    onChangePagingNo(pagingNo: number) {
      this.setHistoryParams({
        pagingNo
      })
      util.scrollToTop()
    },

    /**
     * ページを変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      this.setHistoryParams({
        limitCount
      })
    },

    /**
     * ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSortBy(sortBy: string) {
      if (this.params.sortBy === sortBy) {
        return
      }
      this.setHistoryParams({ sortBy })
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      TrackingService.sendEvent('click:|IWメッセージ一覧(X)|CSVダウンロード')

      try {
        // CSV用履歴一覧を取得
        const histories = await this.getHistoriesForCsv()

        if (!histories || !histories.length) {
          return { error: 'ERROR_LOADING' }
        }

        const filename = `instantwin_message_winner_${moment().format('YYYY_MM_DD')}`
        const csvData = []

        csvData.push([
          '応募日時',
          '種別',
          'メッセージ名',
          'アカウントID',
          'アカウント名',
          'アカウントスクリーン名',
          'アカウントURL',
          'アカウント画像',
          'アカウント説明文',
          'フォロワー',
          'ツイート',
          '応募ツイートURL',
          '応募回数(累計)',
          '応募回数(今回)',
          '当選回数(累計)',
          '当選回数(今回)',
          'フォロー中',
          '回答者'
        ])

        histories.forEach(message => {
          csvData.push([
            formatDatetime(message.entryDatetime),
            message.messageType,
            message.name,
            message.applicant.accountId,
            message.applicant.name,
            message.applicant.screenName,
            'https://twitter.com/' + message.applicant.screenName,
            message.applicant.pictureUrl,
            message.applicant.description ? message.applicant.description.replace(/(\r\n|\n|\r)/gm, '') : '',
            message.applicant.followersCount,
            message.applicant.tweetsCount,
            'https://twitter.com/' + message.applicant.accountId + '/status/' + message.entryTweetId,
            message.totalEntryCount || 0,
            message.currentEntryCount || 0,
            message.totalWinnerCount || 0,
            message.currentWinnerCount || 0,
            message.applicant.isFollowing ? 1 : 0,
            message.applicant.isResponder
          ])
        })

        return {
          filename,
          data: csvData
        }
      } catch {
        return { error: 'ERROR_LOADING' }
      }
    },

    /**
     * CSV用履歴一覧を取得
     */
    async getHistoriesForCsv() {
      this.loading = true
      const total = this.paginations.total

      this.getTextLoading(0, total)

      const params = Object.assign({}, this.params, {
        pagingNo: 1,
        limitCount: 1000
      })

      let totalResults = []
      let fetchedCount = 0

      // 1000件ごとに取得する
      const maxPages = Math.ceil(total / 1000)
      for (let pageIndex = 0; pageIndex < maxPages && fetchedCount < total; pageIndex++) {
        try {
          const result = await api.get('/twitter_instantwin_message_histories', { params })

          if (!result || !result.data || !result.data.histories) {
            throw new Error('ERROR_LOADING')
          }

          const histories = result.data.histories
          if (histories.length === 0) {
            break
          }

          totalResults = totalResults.concat(histories)
          fetchedCount += histories.length

          // 進捗表示を更新
          const displayCount = Math.min(fetchedCount, total)
          this.getTextLoading(displayCount, total)

          params.pagingNo = params.pagingNo + 1

          if (histories.length < 1000) {
            break
          }
        } catch {
          this.loading = false

          return
        }
      }

      this.loading = false
      return totalResults.slice(0, total)
    },

    /**
     * メッセージの一括ダイアログを開く
     */
    openDirectMessageDialog() {
      TrackingService.sendEvent('click:IWメッセージ一覧(X)|一括操作')

      this.$refs.directMessageDialog.open(this.campaignPrize.id, this.campaign.id)
    },

    /**
     * フラグ変更処理
     * @param {{type: string, value: any}} payload
     */
    async changeFlag(payload) {
      const type = payload.type
      const value = payload.value
      let responderResult

      switch (type) {
        case 'responder':
          responderResult = await this.updateResponder(value)
          // エラーがある場合はエラーメッセージを表示
          if (!responderResult.data) {
            this.showError('回答者の保存に失敗しました')
          }
          break
      }
    },

    openMessageHistory(payload) {
      this.$refs.directMessageHistoryDialog.open(payload.applicantId)
    },

    /**
     * エラーを表示
     * @params {string} title タイトル
     * @param {string} message
     */
    showError(title: string, message: string) {
      if (!message) {
        this.$notify({
          title,
          customClass: 'danger',
          duration: 5000
        })
      } else {
        this.$notify({
          title,
          message,
          customClass: 'danger',
          duration: 5000
        })
      }
    },

    /**
     * CSVダウンロードの時、進捗を表示する
     * @params {number} acquiredNumber
     * @params {number} totalNumber
     */
    getTextLoading(acquiredNumber: number, totalNumber: number) {
      if (!totalNumber) {
        this.loadingText = 'CSVファイルの作成中です。しばらくお待ちください。'
        return
      }

      this.loadingText = `CSVファイルの作成中です。しばらくお待ちください。\n ${acquiredNumber}件 / ${totalNumber}件`
    }
  },
  watch: {
    params() {
      this.fetchHistoryList()
    }
  }
})
</script>
